export default __webpack_public_path__ + "static/media/starconch.e6a71caf.png";